export const VERSION_ID = 40604;

export const PLATFORM = "vamoos_web";

export const VERIFICATION_CODE_LENGTH = 6;

export const VAMOOS_URL = "https://www.vamoos.com/";